import { getCustomerImageUploadUrl } from "../../services/documentGeneration.service";

import { useProposalDocument } from "./proposalDocumentsContext";

const CustomerDetails: React.FC = () => {
  const { payload, setPayload, isUploadingImage, setIsUploadingImage } = useProposalDocument();

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploadingImage(true);

    try {
      // Get presigned upload URL & target S3 Key path matching file signature
      const res = await getCustomerImageUploadUrl(file.type);
      const { upload_url, s3_key } = (await res.json()) as {
        upload_url: string;
        s3_key: string;
      };

      // Put raw image binary blob up to S3 bucket directly
      const uploadResponse = await fetch(upload_url, {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      });

      if (!uploadResponse.ok) {
        throw new Error(
          `S3 upload failed: ${uploadResponse.status.toString()} ${uploadResponse.statusText}`,
        );
      }

      // Save the s3_key reference strictly inside payload state object
      setPayload((prev) => ({
        ...prev,
        customer_image: s3_key,
      }));

      console.log("Image successfully uploaded to S3 path:", s3_key);
    } catch (err) {
      console.error("Failed handling customer image lifecycle upload:", err);
      alert("Image upload failed. Check CORS or console logs.");
    } finally {
      setIsUploadingImage(false);
    }
  };

  return (
    <div className="customer-details">
      <div className="customer-details__header">
        <h2>Customer Details</h2>
      </div>

      <div className="customer-details__content">
        <div className="customer-details__grid">
          {/* Customer Name Text Input */}
          <div className="customer-details__field">
            <label htmlFor="customer-details-name" className="customer-details__label">
              Customer Name
            </label>
            <input
              id="customer-details-name"
              type="text"
              className="customer-details__input"
              placeholder="Enter corporate client title..."
              value={payload.customer_name || ""}
              onChange={(e) => {
                setPayload({ ...payload, customer_name: e.target.value });
              }}
            />
          </div>

          {/* Customer Brochure Branding Image Selector */}
          <div className="customer-details__field">
            <label htmlFor="customer-details-image" className="customer-details__label">
              Customer Brand Image (PNG/JPG only)
            </label>
            <div className="customer-details__file-wrapper">
              <input
                id="customer-details-image"
                type="file"
                className="customer-details__input customer-details__input--file"
                accept="image/png, image/jpeg, image/jpg"
                disabled={isUploadingImage}
                onChange={(e) => {
                  void handleImageChange(e);
                }}
              />
              {isUploadingImage && (
                <div className="customer-details__spinner-container">
                  <div className="customer-details__spinner" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>

            {/* Success Validation Message */}
            {payload.customer_image && !isUploadingImage && (
              <div className="customer-details__success-msg">
                <span className="customer-details__success-icon">✓</span>
                Image ready to generate inside brochure layout layer.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
